import { useQuery } from "react-query";
import Axios from "../../../configs/axios/axios-base.config";

export const useGetBanners = (filters) => {
	return useQuery(
		["banners"],
		() => {
			return Axios.get("shared/getBaner", filters).then((res) => res.data);
		},
		{
			refetchOnWindowFocus: false,
		}
	);
};
